import { Box } from '@mui/material'
import React, { PropsWithChildren } from 'react'
import sxs from './_sxs'
import { LogotypeIcon } from '../assets/icons/icons'

const RouterOutsideContainer: React.FC<PropsWithChildren> = ({ children }) => (
    <Box sx={sxs.container}>
        <Box sx={sxs.containerInner}>
            <Box sx={sxs.containerInnerHeader}>
                <LogotypeIcon />
            </Box>
            {children}
        </Box>
    </Box>
)

export default RouterOutsideContainer
